// extracted by mini-css-extract-plugin
export var card = "_uu-0";